import { useIntl } from 'react-intl'
import { Tag } from 'ui'
import { AdvancedConfigProps } from '.'
import { messages } from '../../messages'

export function MostExpensiveTag(props: AdvancedConfigProps) {
  const {
    config: { mostExpensive },
  } = props
  const { $t } = useIntl()
  const {
    benefit: { advanced },
  } = messages

  return <Tag>{$t(advanced.mostExpensive, { value: mostExpensive })}</Tag>
}
